

function ItemChannelTab({ text, num, activeTab, onClick }) {
    return (
        <button
            onClick={() => onClick(num)}
            className={`px-10  pb-2
                    ${activeTab === num ?
                    "border-b-4 border-blue-600 text-black text-base font-bold"
                    :
                    "text-slate-400 text-sm"
                }`}
        >
            {text}
        </button>
    )
}
export default ItemChannelTab;